import { render, staticRenderFns } from "./InterpreterPerformance.vue?vue&type=template&id=56ab65e0&scoped=true&"
import script from "./InterpreterPerformance.vue?vue&type=script&lang=js&"
export * from "./InterpreterPerformance.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterPerformance.vue?vue&type=style&index=0&id=56ab65e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab65e0",
  null
  
)

export default component.exports